import styled from "styled-components";
import colors from "../../../assets/styles/colors";
import ReactTooltip from 'react-tooltip';

export const PoliticallyExposedPersonLabelForm = styled.p`
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.textPrimary};
  margin-top: 30px;
`;

export const PoliticallyExposedPersonLineFormItem = styled.div`
  margin-top: 30px;
`;

export const PoliticallyExposedPersonLineFormHeaderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PoliticallyExposedPersonLineFormLabel = styled.div`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
`;

export const PoliticallyExposedPersonLineFormDeleteItem = styled.span`
  cursor: pointer;
  color: ${colors.bgDanger};
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
`;

export const PoliticallyExposedPersonAddLine = styled.button`
  font-weight: bold;
  border: 0;
  outline: 0;
  margin-top: 20px;
  background-color: transparent;
  font-size: 14px;
  line-height: 17px;
  color: ${colors.bgSecondary};
  cursor: pointer;
`;

export const TooltipTitle = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.03em;
`;

export const TooltipContent = styled.div`
font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.03em;
`;

export const Tooltip = styled(ReactTooltip).attrs({
  className: "custom-tooltip",
})`
  &.custom-tooltip {
    width: 300px !important;
    padding: 13px !important;
    font-family: Montserrat !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 22px !important;
    letter-spacing: 0.03em !important;
    opacity: 1 !important;
    background-color: rgb(187, 215, 212);
  }
`;

export const InfoCircleImage = styled.img`
  margin-bottom:-3px;
  margin-left: 3px;
`;  
